// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1186":"0181b79d1a6aaf50","1646":"510ae2f2cc90e781","5139":"715107020b82813d"}[chunkId] + ".js";
};